import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { store } from './store/store';
import { basename } from './settings';

// wrap all in lazy
// import UI from './components/UI/Test/UI.test';
import App from './components/App/App'; 
// import WagmiWrapper from './components/utilComponents/WagmiWrapper/WagmiWrapper';
import WagmiComp from './components/utilComponents/WagmiComp/WagmiComp';
import ModalsController from './components/modals/ModalsController/ModalsController';
import EscapeHandler from './components/utilComponents/EscapeHandler/EscapeHandler';
import Loader from './components/Loader/Loader';
import IndexWrapper from './components/utilComponents/IndexWrapper/IndexWrapper';

import './scss/index.scss';

const PingPage = lazy(() => import('./components/pages/PingPage/PingPage'));
const DocsPage = lazy(() => import('./components/pages/DocsPage/DocsPage'));
const NewPage = lazy(() => import('./components/pages/NewPage/NewPage'));


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	// <React.StrictMode>
	<>
		<IndexWrapper>
			<Provider store={store}>
				<BrowserRouter basename={basename}>
					<Suspense fallback={<Loader fullScreen/>}>
						<Switch>
							<Route exact path='/ping' component={PingPage}/>
							<Route exact path='/docs' component={DocsPage}/>
							<Route exact path='/new'>
								<WagmiComp/>
								<NewPage/>
								<ModalsController/>
							</Route>
							<Route>
								<EscapeHandler/>
								{/* <WagmiWrapper/> */}
								<WagmiComp/>
								<App/>
								<ModalsController/>
							</Route>
						</Switch>
					</Suspense>
				</BrowserRouter>
			</Provider>
		</IndexWrapper>
	</>
	// </React.StrictMode>
);